module.exports = __webpack_public_path__ + "static/media/52.995317d9.JPG";